export default function getIndianFormat(value) {
  return value && (Intl.NumberFormat('en-IN').format(value));
}
